// A quiz tile previews page 1 exactly as the painter draws it; an uploaded image shows itself. IZTeach units carry no thumbnail,
// so they get '' and the strip draws its kind placeholder.

import { paintQuizPage } from '../quiz/paint';
import type { QuizBody } from '../quiz/body';
import type { BoardDocument } from './documents';

// twice the 160x100 frame, so the tile stays sharp on a 2x panel
const TILE_WIDTH = 320;
const TILE_HEIGHT = 200;

const cache: Record<string, string> = {};

/** Page 1 of a quiz fitted inside a filmstrip frame as a data URL, or '' when there is nothing to paint. */
export function documentThumbnail(item: BoardDocument): string {
  // an uploaded image is its own preview; the frame's img scales it, nothing is painted
  if (item.upload && item.upload.viewer === 'image') return item.upload.url;
  if (!item.quiz) return '';
  if (typeof cache[item.id] === 'string') return cache[item.id];
  cache[item.id] = paint(item.quiz);
  return cache[item.id];
}

function paint(body: QuizBody): string {
  let page: HTMLCanvasElement | null = null;
  try {
    // the tile is a preview, never the live surface, so it always shows the unrevealed page
    page = paintQuizPage(body, 1, false).canvas;
    const tile = window.document.createElement('canvas');
    tile.width = TILE_WIDTH;
    tile.height = TILE_HEIGHT;
    const ctx = tile.getContext('2d');
    if (!ctx) return '';
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, TILE_WIDTH, TILE_HEIGHT);
    // contain, not cover - a cropped slide loses the title line that identifies it
    const scale = Math.min(TILE_WIDTH / page.width, TILE_HEIGHT / page.height);
    const width = Math.round(page.width * scale);
    const height = Math.round(page.height * scale);
    ctx.drawImage(page, Math.round((TILE_WIDTH - width) / 2), Math.round((TILE_HEIGHT - height) / 2), width, height);
    return tile.toDataURL('image/jpeg', 0.82);
  } catch (error) {
    return '';
  } finally {
    // the painted page is 2000px wide - drop its backing store as soon as the tile has its pixels
    if (page) { page.width = 0; page.height = 0; }
  }
}
